import { namespace } from 'vuex-class';
import { IVideoLibraryState } from '@/video/library-old/store/video-library-old.types';

export const VideoLibrary = namespace('video/videoLibraryOld');

export enum EVideoLibraryAction {
  LoadVideos = 'loadVideos',
  LoadVideosSuccess = 'loadVideosSuccess',
  LoadVideosFailed = 'loadVideosFailed',
  DeleteVideo = 'deleteVideo',
  DeleteVideoFailed = 'deleteVideoFailed',
  CopyLinkToClipboard = 'copyLinkToClipboard',
  UpdateVideo = 'updateVideo',
  ToggleDeleteModal = 'toggleDeleteModal',
  Search = 'search',
  SetEditId = 'setEditId',
  ResetState = 'resetState',
}

export enum EVideoLibraryMutation {
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetVideos = 'setVideos',
  SetPagination = 'setPagination',
  DeleteVideo = 'deleteVideo',
  UpdateVideo = 'updateVideo',
  SetDeleteModalVisibility = 'setDeleteModalVisibility',
  SetSearch = 'setSearch',
  SetEditId = 'setEditId',
  SetState = 'setState',
}

export const state: IVideoLibraryState = {
  loading: false,
  loaded: false,
  videos: [],
  search: '',
  pagination: {
    pageSize: 9,
    pageMargin: 0,
    currentPage: 1,
    totalRows: 0,
  },
  videoIdDelete: null,
  videoIdEdit: null,
};
